import { useState } from "react";
import { Gift, X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

export function GiftPremiumModal({ recipient, onClose }) {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const checkout = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/gifts/checkout", {
        recipient_id: recipient.id, message, origin_url: window.location.origin,
      });
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Could not start the gift checkout.");
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-end sm:items-center justify-center" data-testid="gift-modal">
      <div className="absolute inset-0 bg-[#2C2A29]/50 backdrop-blur-[2px]" onClick={onClose} data-testid="gift-overlay" />
      <div className="relative w-full sm:max-w-md bg-[#FDFBF7] border border-[#D9D4CC] sm:rounded-sm shadow-2xl animate-fade-up">
        <button data-testid="gift-close" onClick={onClose} aria-label="Close"
          className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center rounded-sm text-[#7A756E] hover:bg-[#EAE6DF] transition-colors duration-300">
          <X className="w-5 h-5" />
        </button>
        <div className="px-7 sm:px-8 pt-8 pb-8">
          <div className="flex items-center gap-2.5">
            <Gift className="w-5 h-5 text-[#9B7E4E]" strokeWidth={1.5} />
            <p className="font-body text-xs uppercase tracking-[0.2em] text-[#7A756E]">Gift Premium</p>
          </div>
          <h2 className="font-heading text-2xl sm:text-3xl text-[#2C2A29] tracking-tight mt-3">
            Bless <span className="text-[#9B7E4E]" data-testid="gift-recipient-name">{recipient.name || "this believer"}</span> with a month of Premium
          </h2>
          <p className="font-decree text-lg text-[#4A4744] mt-3 leading-relaxed">
            One-time $4.99. They get 30 days of unlimited decrees, full plans, every teaching, unlimited word studies and all nine translations — and a note from you on the Newsfeed.
          </p>
          <label className="block mt-5 font-body text-xs uppercase tracking-[0.15em] text-[#7A756E]">A short blessing (optional)</label>
          <textarea
            data-testid="gift-message"
            value={message}
            onChange={(e) => setMessage(e.target.value.slice(0, 200))}
            rows={3}
            placeholder="May the Lord establish every word you decree…"
            className="mt-2 w-full bg-[#FAF9F6] border border-[#D9D4CC] rounded-sm px-4 py-3 font-decree text-base text-[#2C2A29] placeholder:text-[#B7AE9F] focus:outline-none focus:border-[#9B7E4E] transition-colors duration-300"
          />
          <p className="font-body text-xs text-[#B7AE9F] text-right mt-1">{message.length}/200</p>
          <button
            data-testid="gift-checkout-button"
            onClick={checkout}
            disabled={loading}
            className="mt-4 w-full flex items-center justify-center gap-2 px-5 py-3.5 bg-[#9B7E4E] text-[#FAF9F6] rounded-sm hover:opacity-90 transition-opacity duration-300 disabled:opacity-50"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Gift className="w-4 h-4" />}
            Gift one month · $4.99
          </button>
          <p className="font-body text-xs text-[#7A756E] mt-3 text-center">Secure checkout by Stripe. Gifts are non-refundable.</p>
        </div>
      </div>
    </div>
  );
}
